export default __webpack_public_path__ + "static/media/headset_mic.aa124ca7.svg";